import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    isLog: !!localStorage.getItem('situation'),
    register : !!localStorage.getItem('token'),
    isRoot : !!localStorage.getItem('isroot'),
  },

  mutations: {
    registerExit(state){
  
      state.register = true
    },
    loginUser(state) {
      state.isLoggedIn = true
      state.isLog = true
      state.isRoot = true
    },

    logoutUser(state) {
      state.isLoggedIn = false
      state.isLog = false
      state.isRoot = false
    }

  }
})
